<template>
	<div class="laboratory_editor">
		<!-- 引入 TinyMCE 编辑器 -->
		<Editor
			class="ql-editor"
			v-model="content"
			api-key="l7sh2dxxrs3sxl7jtclbldfqtbtl3lm393r8ohnocscg0l0s"
			:init="editorInit"
		/>
	</div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";

export default {
	components: {
		Editor,
	},
	data() {
		return {
			content: "", // 编辑器的内容
			editorInit: {
				height: 500, // 编辑器高度
				selector: "textarea", // change this value according to your HTML

				content_css: "assets/article.css", // 相对路径
				plugins:
					"advlist autolink lists link image charmap print preview anchor searchreplace", // 添加 searchreplace 插件
				toolbar:
					"undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | searchreplace | help", // 添加搜索按钮
			},
		};
	},
};
</script>

<style scoped>
.laboratory_editor {
	margin: 20px;
}
</style>
